<template>
  <Modal
    :title="'Alterar dados do boleto'"
    :active="active"
    @close="close()"
    id="modal-update-billet-data"
  >
    <vs-alert
      color="warning"
      active="true"
      class="my-3"
      style="height: auto !important; color: #000000b3"
    >
      <div class="flex items-center">
        <vs-icon
          class="mr-2"
          size="small"
          color="warning"
          icon-pack="feather"
          icon="icon-alert-triangle"
        ></vs-icon>
        <span
          ><b>Atenção:</b> tem certeza que deseja alterar esse boleto? Após
          confirmar, não será possível desfazer a alteração.</span
        >
      </div>
    </vs-alert>
    <div class="my-2">
      <p>
        <b>Boleto original:</b>
      </p>
      <p>
        Valor: {{ functions.formataReal(originalBilletInfo.originalValue) }}
      </p>
      <p>Data de vencimento: {{ originalBilletInfo.originalDueDate }}</p>
      <p>
        Data limite de pagamento:
        {{ originalBilletInfo.originalDuePaymentDate }}
      </p>
    </div>
    <ValidationObserver
      role="form"
      ref="formEditFinancialRecord"
      v-if="form.financialRecordId"
      v-slot="{ invalid }"
    >
      <ValidationProvider
        v-if="paymentMethods.length > 0 && !form.ourNumber"
        name="Forma de Pagamento"
        class="flex flex-col w-full mb-2"
        rules="required"
      >
        <label for="" class="vs-select--label">Forma de Pagamento</label>
        <v-select
          :options="paymentMethods"
          id="Forma de Pagamento"
          v-model="form.companyPaymentMethodId"
          label="nomePagamento"
          data-testid="payment-method-select"
        >
        </v-select>
        <span
          v-show="!!errors.length"
          class="text-danger text-sm"
          data-testId="payment-method-error"
          >{{ errors[0] }}
        </span>
      </ValidationProvider>

      <ValidationProvider
        v-if="selectedBilletTypeId !== 1"
        name="Tipo de Boleto"
        class="flex flex-col w-full mb-2"
        rules="required"
        v-slot="{ errors }"
      >
        <label for="" class="vs-select--label">Tipo de Boleto</label>
        <v-select
          :options="billetTypes"
          id="Tipo de Boleto"
          v-model="form.billetTypeId"
          :reduce="(item) => item.billetTypeId"
          :class="{ 'has-error': errors.length }"
          label="tipoBoleto"
          data-testid="billet-type-select"
        >
        </v-select>
        <span
          v-show="!!errors.length"
          class="text-danger text-sm"
          data-testId="billet-type-error"
          >{{ errors[0] }}
        </span>
      </ValidationProvider>
      <div class="flex gap-4">
        <ValidationProvider
          name="Valor"
          class="flex flex-col w-full mb-2"
          rules="required|min_value:2"
          v-slot="{ errors }"
        >
          <label for="" class="vs-input--label">Valor</label>
          <Money
            class="w-full vs-inputx vs-input--input normal"
            id="Valor"
            name="Valor"
            :disabled="Boolean(form.applyInterestFine)"
            v-model="form.newValue"
            :class="{ 'has-error': errors.length }"
            data-testid="billet-value-input"
          ></Money>
          <span
            v-show="!!errors.length"
            class="text-danger text-sm"
            data-testId="billet-value-error"
            >{{ errors[0] }}
          </span>
        </ValidationProvider>

        <ValidationProvider
          name="Data de Vencimento"
          rules="required|isMoreOrSameThanToday"
          class="flex flex-col w-full mb-2"
          v-slot="{ errors }"
        >
          <label for="" class="vs-input--label">Data de Vencimento</label>
          <flat-pickr
            id="Início Vigência"
            v-model="form.newDueDate"
            :config="{ ...configDateTimePickerDay }"
            placeholder="DD/MM/AAAA"
            class="flatpickr-input"
            :class="{ 'has-error': errors.length }"
            data-testid="billet-due-date-input"
          />
          <span
            v-show="!!errors.length"
            class="text-danger text-sm"
            data-testId="billet-due-date-error"
            >{{ errors[0] }}
          </span>
        </ValidationProvider>

        <div class="flex w-full gap-2">
          <ValidationProvider
            name="Aplicar Juros e Multa?"
            rules="required"
            class="flex flex-col w-full mb-2"
            v-slot="{ errors }"
          >
            <label for="apply-interest-select" class="vs-input--label"
              >Aplicar Juros e Multa?</label
            >
            <v-select
              id="apply-interest-select"
              data-testid="apply-interest-fine-select"
              v-model="form.applyInterestFine"
              :options="applyInterestFineOptions"
              :reduce="(item) => item.id"
              placeholder="Selecione"
              :class="{ 'has-error': errors.length }"
            />
            <span
              v-show="!!errors.length"
              class="text-danger text-sm"
              data-testId="apply-interest-fine-error"
              >{{ errors[0] }}
            </span>
          </ValidationProvider>
          <vs-icon
            v-tooltip="
              'O valor será recalculado com base no valor e vencimento originais, de acordo com o novo vencimento.'
            "
            icon="help"
            size="small"
            color="primary"
            class="mt-8"
          ></vs-icon>
        </div>
      </div>
      <div class="flex justify-end items-end w-full text-right mt-2 gap-4">
        <vs-button
          color="dark"
          type="gradient"
          html-type="button"
          icon-pack="feather"
          class="d-inline"
          @click="close()"
          >Cancelar
        </vs-button>
        <vs-button
          :disabled="
            invalid || !form.newDueDate || form.applyInterestFine == null
          "
          color="success"
          type="gradient"
          icon-pack="feather"
          class="d-inline"
          @click="updateBillet()"
          >Confirmar
        </vs-button>
      </div>
    </ValidationObserver>
  </Modal>
</template>
<script>
import { Portuguese } from 'flatpickr/dist/l10n/pt.js';
import { Money } from 'v-money';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import flatPickr from 'vue-flatpickr-component';
import VueSelect from 'vue-select';
import Modal from '../../components/Modal.vue';
import billetApiService from '../../services/billet.api';
import functions from '../../utils/functions';
import notify from '../../utils/notify';

export default {
  name: 'ModalUpdateBilletData',
  components: {
    Modal,
    ValidationObserver,
    ValidationProvider,
    'v-select': VueSelect,
    Money,
    flatPickr,
  },
  props: {
    originalBilletInfo: {
      type: Object,
      default: () => ({}),
    },
    formEditBillet: {
      type: Object,
      default: () => ({}),
    },
    paymentMethods: {
      type: Array,
      default: () => [],
    },
    billetTypes: {
      type: Array,
      default: () => [],
    },
    selectedBilletTypeId: {
      type: Number,
      default: 0,
    },
    activeModal: {
      type: Boolean,
      default: false,
    },
    finishBilletModal: {
      type: Function,
      default: () => {},
    },
    toSearchHistoryData: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    functions() {
      return functions;
    },
    active() {
      return this.activeModal;
    },
  },
  watch: {
    formEditBillet: {
      handler(newVal) {
        if (!newVal) return;

        if (this.form.financialRecordId !== newVal.idRegistroFinanceiro) {
          this.setFormValues();
        }
      },
      immediate: true,
      deep: false,
    },
    'form.applyInterestFine'(newValue) {
      if (!newValue) {
        this.form.newValue = this.formEditBillet.valor;
        return;
      }
      this.getInterestFineValue();
    },
    'form.newDueDate'() {
      this.getInterestFineValue();
    },
  },
  data() {
    const emptyForm = {
      billetTypeId: 0,
      companyPaymentMethodId: 0,
      ourNumber: '',
      newValue: 0,
      newDueDate: null,
      financialRecordId: null,
      applyInterestFine: null,
    };
    const applyInterestFineOptions = [
      { id: 0, label: 'Não' },
      { id: 1, label: 'Sim' },
    ];

    return {
      emptyForm,
      applyInterestFineOptions: applyInterestFineOptions,
      form: { ...emptyForm },
      configDateTimePickerDay: {
        minDate: 'today',
        dateFormat: 'd/m/Y',
        locale: Portuguese,
        time_24hr: true,
      },
    };
  },
  methods: {
    resetFormValues() {
      this.form = { ...this.emptyForm };
    },
    setFormValues() {
      if (!this.formEditBillet) this.resetFormValues();
      this.form.billetTypeId = this.formEditBillet.idTipoBoleto;
      this.form.companyPaymentMethodId =
        this.formEditBillet.idTipoPagamentoEmpresa;
      this.form.ourNumber = this.formEditBillet.nossoNumero;
      this.form.newValue = this.formEditBillet.valor;
      this.form.newDueDate = this.formEditBillet.dataVencimento;
      this.form.financialRecordId = this.formEditBillet.idRegistroFinanceiro;
      this.form.applyInterestFine = null;
    },
    async getInterestFineValue() {
      if (!this.form.applyInterestFine) return;
      const isValid = await this.$refs.formEditFinancialRecord.validate();
      if (!isValid) {
        return;
      }
      this.$vs.loading();
      try {
        const value = await billetApiService.getInterestFineValueBillet(
          this.form.financialRecordId,
          this.form.newDueDate,
        );
        this.form.newValue = value;
      } catch (error) {
        console.error('Erro ao calcular juros e multa:', error);
        notify.notifyFail(this.$vs, 'Erro ao calcular juros e multa');
      } finally {
        this.$vs.loading.close();
      }
    },
    close() {
      this.$emit('close');
      this.resetFormValues();
    },
    async updateBillet() {
      const isValid = await this.$refs.formEditFinancialRecord.validate();
      if (!isValid) {
        return;
      }
      this.$vs.loading();
      const payload = {
        action: 'UPDATE_DUE_OR_VALUE',
        newValue: this.form.newValue,
        newDueDate: this.form.newDueDate,
      };

      try {
        await billetApiService.updateBillet(
          this.form.financialRecordId,
          payload,
        );
        this.finishBilletModal(true, 'Boleto atualizado com sucesso');
      } catch (error) {
        this.finishBilletModal(false, 'Falha ao atualizar boleto');
      } finally {
        this.$vs.loading.close();
      }
    },
  },
};
</script>
<style>
#modal-update-billet-data .vs-popup {
  width: 1024px !important;
  max-width: 95% !important;
}

#modal-update-billet-data .flatpickr-input {
  width: 100% !important;
}

.tooltip {
  z-index: 54000;
}
</style>
